import { mapGetters, mapActions } from 'vuex'

export const documentsActions = {
  ...mapActions('documents', [
    'getDocuments',
    'getDocumentsByFolder',
    'deleteDocument',
    'updateDocument',
    'updateDocumentInStorage',
    'addDocumentInStorage',
    'clearDocumentInStorage',
    'signDocumentInStorage',
    'createDocumentConstancy'
  ])
}

export const documentsData = {
  ...mapGetters('documents', [
    'documents',
    'documentsByFolder',
    'documentsTotal',
    'documentsHeaders',
    'isDocumentsBusy',
    'loadingText',
    'noDataText',
    'documentSignLabels',
    'documentGenerateConstancies',
    'documentDeleteLabels',
    'msgDocumentServiceError'
  ])
}
